import { api } from "./client";
import type { Exam, ExamCreate, ExamDetail, ExamUpdate } from "@/types";

export const examsApi = {
  getAll(page = 1, pageSize = 20) {
    return api.get<Exam[]>("/exams", { page, page_size: pageSize });
  },

  getById(id: string) {
    return api.get<ExamDetail>(`/exams/${id}`);
  },

  create(data: ExamCreate) {
    return api.post<Exam>("/exams", data);
  },

  update(id: string, data: ExamUpdate) {
    return api.patch<Exam>(`/exams/${id}`, data);
  },

  delete(id: string) {
    return api.delete<void>(`/exams/${id}`);
  },
};
